import React, {useEffect, useState} from 'react';
import {AutoComplete, Spin} from 'antd';
import SharedService from "../../../services/shared/service";


const SupplierAutoComplete = ({user, supplier = null, onSelectSupplier }) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState(supplier?.name || '');

    useEffect(() => {
        if (supplier) {
            const option = {
                value: supplier.id,
                label: supplier.name,
            };
            setOptions([option]);
            setSelectedValue({
                    label: supplier.name,
                    value: supplier.id
            })
        }
    }, [supplier]);

    const handleClear = () => {
        setSelectedValue(null);
        onSelectSupplier(null)
        setOptions([]);
    };

    const handleSearch = (searchTerm) => {
        setSelectedValue(searchTerm); // 💡 This clears old selection

        if (searchTerm.length > 3) {
            setLoading(true);

            const data = {
                searchTerm: searchTerm,
            }

            SharedService.post({
                token: user.token,
                data: data,
                url: "supplier/search/autocomplete?select=id,name,email,country"
            })
                .then(response => {

                    const supplierOptions = response?.map((item) => ({
                        value: item.id,
                        label: item.name,
                    })) ?? [];

                    setOptions(supplierOptions);

                })
                .catch(errorInfo => {
                    console.error("SupplierAutoComplete Error:", errorInfo);
                })
                .finally(() => setLoading(false));
        } else {
            setOptions([]); // Clear options if too few characters
        }
    }

    return (
        <AutoComplete
            loading={loading}
            options={options}
            allowClear={true}
            autoClearSearchValue={true}
            onSearch={handleSearch}
            value={selectedValue?.label}
            onFocus={handleClear}
            onSelect={(value, option) => {
                setSelectedValue({
                    label: option.label,
                    value
                });
                onSelectSupplier(option);
            }}
            placeholder="Select supplier"
            notFoundContent={loading ? <Spin size="small"/> : 'No suppliers found'}
        >
        </AutoComplete>
    )
}

export default SupplierAutoComplete;